import { getRowDataToPass } from "./rowDataUtils";

export const handleRowClickAction = (
  tableData: any,
  rowIndex: number,
  className: string,
  startIndex: number,
  props: {
    onReviewButtonClick?: (rowData: any) => void;
    onPatientDetailsClick?: (rowData: any) => void;
    onRowClick?: (rowData: any) => void;
    onDeleteIconClick?: (rowData: any) => void;
    onClickableTextWithDisabledStatusClick?: (rowData: any) => void;
    onReRunOncoEmrClick?: (rowData: any) => void;
    onReRunCmmClick?: (rowData: any) => void;
    onViewCmmClick?: (rowData: any) => void;
    onViewPharmaPaDiffCommentClick?: (rowData: any) => void;
    onViewCommentClick?: (rowData: any) => void;
    onTextNoteClick?: (rowData: any) => void;
    onNotesIconClick?: (rowData: any) => void;
    onLetterUploadClick?: (rowData: any) => void;
    onAddKeyButtonClick?: (rowData: any) => void;
    onAppealInfoButtonClick?: (rowData: any) => void;
    handleDownloadButtonClick?: (id: string) => void;
    onViewClinicalNoteClick?: (rowData: any) => void;
    onReportPrescriptionClick?: (rowData: any) => void;
    onRowExpansionChangeFromTableBody?: (expanded: boolean, id: string) => void;
    onViewClick?: (rowData: any) => void;
    onBiosimilarCaseBadgeClick?: (rowData: any) => void;
    onSendToAppealBadgeClick?: (rowData: any) => void;
    onCallingHistoryClick?: (rowData: any) => void;
  },
  cellHeader?: string,
  cellType?: string,
): void => {
  const rowDataToPass = getRowDataToPass(tableData, rowIndex, startIndex);

  if (
    cellType === "actionable-input" ||
    cellType === "tag-with-dropdown-menu"
  ) {
    return;
  }

  // Check by cell header (column key) and type for better maintainability
  if (
    cellHeader === "callingHistoryIcon" &&
    cellType === "calling-history-icon"
  ) {
    props.onCallingHistoryClick?.(rowDataToPass);
    return;
  }
  if (cellHeader === "orderNotesIcon" && cellType === "notes-icon") {
    props.onNotesIconClick?.(rowDataToPass);
    return;
  }
  if (
    cellHeader === "insuranceInfoIcon" &&
    cellType === "insurance-info-icon"
  ) {
    return;
  }
  if (cellHeader === "textNote" && cellType === "badge-button") {
    props.onTextNoteClick?.(rowDataToPass);
    return;
  }
  if (cellHeader === "letterUpload" && cellType === "badge-button") {
    props.onLetterUploadClick?.(rowDataToPass);
    return;
  }
  if (cellHeader === "cmm" && cellType === "badge-button") {
    props.onViewCmmClick?.(rowDataToPass);
    return;
  }
  if (cellHeader === "appealInfo" && cellType === "add-key-button") {
    props.onAppealInfoButtonClick?.(rowDataToPass);
    return;
  }
  if (cellHeader === "biosimilarCase" && cellType === "badge-button") {
    props.onBiosimilarCaseBadgeClick?.(rowDataToPass);
    return;
  }
  if (cellHeader === "sendToAppeal" && cellType === "badge-button") {
    props.onSendToAppealBadgeClick?.(rowDataToPass);
    return;
  }

  // Fall back to className checking for other cases
  if (
    className.includes("button-link__button") ||
    className.includes("status-button__status") ||
    className.includes("button-link__viewDetails") ||
    className.includes("button-link__cmm")
  ) {
    props.onReviewButtonClick?.(rowDataToPass);
  } else if (className.includes("info__authRequired")) {
    navigator.clipboard.writeText(rowDataToPass.docId);
  } else if (
    className.includes("multiline__patientName") ||
    className.includes("multiline__patientDetails")
  ) {
    props.onPatientDetailsClick?.(rowDataToPass);
  } else if (className.includes("copy-data__cmmKey")) {
    navigator.clipboard.writeText(rowDataToPass.cmmKey);
  } else if (className.includes("delete-icon__pocConfigRowDelete")) {
  } else if (className.includes("notes-icon__orderNotesIcon")) {
    props.onNotesIconClick?.(rowDataToPass);
  } else if (className.includes("insurance-info-icon__insuranceInfoIcon")) {
    return;
  } else if (className.includes("delete-icon__cmmOrderDeleteIcon")) {
    props.onDeleteIconClick?.(rowDataToPass);
  } else if (
    className.includes("clickable-text-with-disabled-status__downloadFile")
  ) {
    props.onClickableTextWithDisabledStatusClick?.(rowDataToPass);
  } else if (className.includes("button-link__reRunOncoEmr")) {
    props.onReRunOncoEmrClick?.(rowDataToPass);
  } else if (className.includes("button-link__reRunCmm")) {
    props.onReRunCmmClick?.(rowDataToPass);
  } else if (className.includes("button-link__viewCmmInput")) {
    props.onViewCmmClick?.(rowDataToPass);
  } else if (className.includes("button-link__pharmaPaDiffAction")) {
    props.onViewPharmaPaDiffCommentClick?.(rowDataToPass);
  } else if (className.includes("button-link__pharmaPaDiffViewComment")) {
    props.onViewCommentClick?.(rowDataToPass);
  } else if (className.includes("button-link__textNote")) {
    props.onTextNoteClick?.(rowDataToPass);
  } else if (className.includes("download-button__pdfEmbedPage")) {
    props.handleDownloadButtonClick?.(rowDataToPass.id);
  } else if (className.includes("view-icon__viewInfoForAuditTrial")) {
    return;
  } else if (className.includes("add-key-button__add")) {
    props.onAddKeyButtonClick?.(rowDataToPass);
  } else if (className.includes("add-key-button__submit")) {
    props.onAddKeyButtonClick?.(rowDataToPass);
  } else if (className.includes("button-link__reportPrescriptionInaccuracy")) {
    props.onReportPrescriptionClick?.(rowDataToPass);
  } else if (className.includes("add-key-button__sftp")) {
    props.onAddKeyButtonClick?.(rowDataToPass);
  } else if (className.includes("add-key-button__action")) {
    props.onAddKeyButtonClick?.(rowDataToPass);
  } else if (className.includes("button-link__task")) {
    props.onViewClinicalNoteClick?.(rowDataToPass);
  } else if (className.includes("button-link__clinical")) {
    props.onViewClinicalNoteClick?.(rowDataToPass);
  } else if (className.includes("button-link__cmm")) {
    props.onViewCmmClick?.(rowDataToPass);
  } else if (className.includes("expandable-row-icon__expandableRowIcon")) {
    props.onRowExpansionChangeFromTableBody?.(
      rowDataToPass.isExpanded,
      rowDataToPass.id,
    );
  } else if (className.includes("button-link__view")) {
    props.onViewClick?.(rowDataToPass);
  } else if (className.includes("string-link__task")) {
    props.onViewClick?.(rowDataToPass);
  } else {
    props.onRowClick?.(rowDataToPass);
  }
};
